var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23255 15C1.08767 15 0.94604 14.9571 0.82557 14.8766C0.705101 14.7961 0.611205 14.6817 0.555759 14.5479C0.500314 14.414 0.485809 14.2668 0.514081 14.1247C0.542352 13.9826 0.61213 13.852 0.714587 13.7496L14.2495 0.214548C14.3869 0.0771753 14.5732 0 14.7675 0C14.9618 0 15.1481 0.0771753 15.2855 0.214548C15.4228 0.351921 15.5 0.538239 15.5 0.732514C15.5 0.926788 15.4228 1.11311 15.2855 1.25048L1.75051 14.7855C1.68255 14.8536 1.60181 14.9076 1.51292 14.9444C1.42403 14.9813 1.32875 15.0001 1.23255 15Z",
    fill: "#39695B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7675 15C14.6712 15.0001 14.576 14.9813 14.4871 14.9444C14.3982 14.9076 14.3174 14.8536 14.2495 14.7855L0.714546 1.25048C0.577175 1.11311 0.5 0.926788 0.5 0.732514C0.5 0.538239 0.577175 0.351921 0.714546 0.214548C0.851918 0.0771753 1.03823 0 1.23251 0C1.42678 0 1.6131 0.0771753 1.75047 0.214548L15.2854 13.7496C15.3879 13.852 15.4576 13.9826 15.4859 14.1247C15.5142 14.2668 15.4997 14.414 15.4442 14.5479C15.3888 14.6817 15.2949 14.7961 15.1744 14.8766C15.054 14.9571 14.9123 15 14.7675 15Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.460babc6672b53c6c5839846055930b4.svg";
export { ForwardRef as ReactComponent };